import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const Subcontract = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['subcontract', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "sub_status")
        .then((res: any) => {
          let options = res.result.sub_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(options)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('subcontractor_information')}
    tableConfig={{
      key: "id",
      apiPath: "subcontract/list",
      allowDelete: {
        visible: true,
        key: "sub_id",
        apiPath: "subcontract/delete",
        paramType: "body"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'sub_name',
          caption: t('subcontractor'),
          allowFiltering: true
        },
        {
          dataField: 'contact_name',
          caption: t('contact_name'),
          allowFiltering: true
        },
        {
          dataField: 'contact_tel',
          caption: t('phone_number'),
        },
        {
          dataField: 'address',
          caption: t('address'),
        },
        {
          dataField: 'activate_code',
          caption: "Activate Code"
        },
        {
          dataField: 'owner_name',
          caption: t('affiliation'),
          allowFiltering: true
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by')
        }
      ],
      exportExcel: {
        fileName: t('subcontractor_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('subcontractor'), value: 'sub_name' },
          { label: t('contact_name'), value: 'contact_name' },
          { label: t('phone_number'), value: 'contact_tel' },
          { label: t('address'), value: 'address' },
          { label: 'Activate Code', value: 'activate_code' },
          { label: t('affiliation'), value: 'owner_name' },
          { label: t('status'), value: 'status_name' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      sub_name: "",
      description: "",
      address: "",
      contact_name: false,
      contact_tel: false,
      lat: "",
      lon: "",
      status: "Y",
      owner: "",
      log_vat: 1,
      min_drop: "",
      max_drop: ""
    }}
    modalConfig={{
      screenName: "subcontract",
      visible: true,
      title: t('subcontractor'),
      required: ["sub_name", "contact_tel"],
      fieldTypeNumber: ["owner"],
      paramName: "sub_id",
      apiPath: {
        "get": '',
        "post": 'subcontract/add',
        "put": 'subcontract/update'
      },
      elements: [
        {
          fieldName: "sub_name",
          label: t('subcontractor'),
          placeholder: t('subcontractor'),
          required: true,
          inputType: "text",
        },
        {
          fieldName: "contact_name",
          label: t('contact_name'),
          placeholder: t('contact_name'),
          required: false,
          inputType: "text",
        },
        {
          fieldName: "contact_tel",
          label: t('phone_number'),
          placeholder: t('phone_number'),
          required: true,
          inputType: "text",
        },
        {
          fieldName: "address",
          label: t('address'),
          placeholder: t('address'),
          required: false,
          inputType: "text",
        },
        {
          fieldName: "lat",
          label: t('latitude'),
          placeholder: t('latitude'),
          required: false,
          inputType: "text",
        },
        {
          fieldName: "lon",
          label: t('longitude'),
          placeholder: t('longitude'),
          required: false,
          inputType: "text",
        },
        {
          fieldName: "activate_code",
          label: "Activate Code",
          placeholder: "Activate Code",
          required: false,
          disabled: true,
          inputType: "text",
        },
        {
          fieldName: "owner",
          label: t('affiliation'),
          inputType: "select",
          defaultValue: 2,
          options: [
            {
              label: "บริษัท",
              value: 1
            },
            {
              label: "ภายนอก",
              value: 2
            }
          ]
        },
        {
          fieldName: "description",
          label: t('additional_details'),
          placeholder: t('additional_details'),
          rows: 3,
          required: false,
          inputType: "text",
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: optionStatus
        },
        {
          fieldName: "log_vat",
          label: t('shipping_tax_percent'),
          placeholder: t('shipping_tax_percent'),
          defaultValue: 1,
          min: 0,
          inputType: "number"
        },
        {},
        {
          fieldName: "min_drop",
          label: t('minimum_quantity'),
          placeholder: t('minimum_quantity'),
          min: 0,
          inputType: "number"
        },
        {
          fieldName: "max_drop",
          label: t('maximum_quantity'),
          placeholder: t('maximum_quantity'),
          min: 0,
          inputType: "number"
        },
      ]
    }}
  />
}))

export default Subcontract